import React from 'react'

export const IconCircleCheck = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="26" height="26" viewBox="0 0 26 26" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24.4 13C24.4 19.296 19.296 24.4 13 24.4C6.70395 24.4 1.6 19.296 1.6 13C1.6 6.70395 6.70395 1.6 13 1.6C19.296 1.6 24.4 6.70395 24.4 13ZM26 13C26 20.1797 20.1797 26 13 26C5.8203 26 0 20.1797 0 13C0 5.8203 5.8203 0 13 0C20.1797 0 26 5.8203 26 13ZM20.0473 9.58383C20.3697 9.28164 20.386 8.77537 20.0838 8.45304C19.7816 8.13072 19.2754 8.11438 18.953 8.41657L11.5181 15.3868L8.56588 12.4345C8.25346 12.1221 7.74693 12.1221 7.43451 12.4345C7.12209 12.7469 7.12209 13.2535 7.43451 13.5659L10.866 16.9974C11.2095 17.3409 11.7636 17.3498 12.118 17.0176L20.0473 9.58383Z"
      fill="currentColor"
    />
  </svg>
)
